// removed by extract-text-webpack-plugin
module.exports = {"sec":"PagesLinks__sec__2DjwuNb1","new":"PagesLinks__new__1-IZ_GmK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PagesLinks/PagesLinks.scss
// module id = dUoe
// module chunks = 0